(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('ul'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
this.elements.input.value = event.currentTarget.dataset.value;
this.querySelector('form')?.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerWrapper = document.querySelector('.header-wrapper')
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

//if (this.headerIsAlwaysSticky) {
//this.header.classList.add('shopify-section-header-sticky');
//this.header.classList.add('always-fixed');
//};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.searchOverlay = document.querySelector('.search-modal__overlay');

	if (this.searchOverlay) {
		this.searchOverlay.addEventListener('click', function(){
			const searchModal = document.querySelector('details-modal');
			searchModal.close();
		})
	}

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 50) {
	this.header.classList.add('shopify-section-header-sticky');
};

if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight / 2) {
	this.header.classList.remove('shopify-section-header-sticky');
};
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
}else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-age-gate"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-age-gate')) {
  customElements.define('sl-age-gate', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const preview = this.dataset.preview === 'true' || new URLSearchParams(location.search).get('sl_age_preview') === '1';
      const verified = document.cookie.split(';').some(cookie => cookie.trim() === 'sl_age_verified=1');
      this.dialog.addEventListener('cancel', event => event.preventDefault(), options);
      this.querySelector('[data-age-no]').addEventListener('click', () => {
        this.querySelector('[data-age-question]').hidden = true;
        const declined = this.querySelector('[data-age-declined]');
        declined.hidden = false;
        this.dialog.setAttribute('aria-labelledby', declined.querySelector('h2').id = `${this.dialog.getAttribute('aria-labelledby')}-declined`);
        this.dialog.removeAttribute('aria-describedby');
        declined.focus();
      }, options);
      this.querySelector('[data-age-back]').addEventListener('click', () => {
        this.querySelector('[data-age-declined]').hidden = true;
        const question = this.querySelector('[data-age-question]');
        question.hidden = false;
        this.dialog.setAttribute('aria-labelledby', question.querySelector('h2').id);
        this.dialog.setAttribute('aria-describedby', question.querySelector('p').id);
        this.querySelector('[data-age-no]').focus();
      }, options);
      this.querySelector('[data-age-yes]').addEventListener('click', () => {
        if (!preview) {
          const days = Math.max(1, Math.min(365, Number(this.dataset.rememberDays) || 30));
          document.cookie = `sl_age_verified=1; Max-Age=${days * 86400}; Path=/; SameSite=Lax; Secure`;
        }
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }, options);
      if (!verified || preview) {
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-age-no]').focus();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-featured-beers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-beer-carousel')) {
  customElements.define('sl-beer-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-beer-carousel__track');
      this.slides = [...this.querySelectorAll('.sl-beer-slide')];
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.current = 0;
      this.querySelector('.sl-beer-carousel__controls').hidden = false;
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.go(this.current + Number(button.dataset.direction)), options);
      });
      this.dots.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.slideIndex)), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.slides.length - 1);
        else this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, options);
      this.observer = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' });
        this.update();
      });
      this.observer.observe(this.track);
      this.update();
    }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
    }
    update() {
      this.current = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
      this.dots.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.current)));
      this.querySelector('.sl-beer-carousel__count').textContent = `${this.current + 1} / ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-taproom-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.menuBoardReady) return;
    root.dataset.menuBoardReady = 'true';
    const nav = root.querySelector('[data-menu-tabs]');
    const tabs = Array.from(root.querySelectorAll('[data-menu-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-menu-panel]'));
    const activate = (name, focus = false) => {
      tabs.forEach(tab => {
        const active = tab.dataset.menuTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.menuPanel !== name; });
    };
    const fromHash = () => {
      const map = {'#sl-on-tap':'beer','#sl-menu-cocktails':'cocktail','#sl-menu-food':'food','#sl-menu-non-alc':'non_alc'};
      if (map[location.hash]) activate(map[location.hash]);
    };
    nav.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.addEventListener('click', () => activate(tab.dataset.menuTab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next].dataset.menuTab, true); }
      });
    });
    panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs.find(tab => tab.dataset.menuTab === panel.dataset.menuPanel).id);
      panel.tabIndex = 0;
    });
    nav.hidden = false;
    activate('beer');
    fromHash();
    window.addEventListener('hashchange', fromHash);
  };
  document.querySelectorAll('[data-sl-menu-board]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sl-menu-board]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-wholesale"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.tradeReady) return;
    root.dataset.tradeReady = 'true';
    const input = root.querySelector('[data-trade-search]');
    const select = root.querySelector('[data-trade-category]');
    const rows = Array.from(root.querySelectorAll('[data-trade-row]'));
    const status = root.querySelector('[data-trade-count]');
    const empty = root.querySelector('[data-trade-empty]');
    const normalise = value => value.normalize('NFKD').toLowerCase().replace(/\p{Diacritic}/gu, '');
    const update = () => {
      const query = normalise(input.value.trim());
      let count = 0;
      rows.forEach(row => {
        const show = (select.value === 'all' || row.dataset.category === select.value) && normalise(row.textContent).includes(query);
        row.hidden = !show;
        if (show) count++;
      });
      status.textContent = status.dataset.countLabel.replace('[count]', count);
      empty.hidden = count !== 0;
    };
    input.addEventListener('input', update);
    select.addEventListener('change', update);
    root.querySelector('[data-trade-tools]').hidden = false;
    update();
  };
  document.querySelectorAll('[data-sl-trade]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sl-trade]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
